import { api } from "@/lib/api";

// Shared blob-URL cache so image thumbnails + lightbox reuse a single fetch per attachment.
const cache = new Map(); // id -> { promise, url }

export function getAttachmentUrl(id) {
  const hit = cache.get(id);
  if (hit) return hit.promise;
  const promise = api.get(`/attachments/${id}`, { responseType: "blob" })
    .then((r) => {
      const url = URL.createObjectURL(r.data);
      cache.set(id, { promise, url });
      return url;
    })
    .catch((e) => { cache.delete(id); throw e; });
  cache.set(id, { promise });
  return promise;
}

export function invalidateAttachment(id) {
  const hit = cache.get(id);
  if (hit?.url) URL.revokeObjectURL(hit.url);
  cache.delete(id);
}
